export function setData(state, data){
    state.data = data;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}



// WEBPACK FOOTER //
// ./src/modules/load_images/mutations.js